export const SORT = {
    asc: 'asc',
    desc: 'desc'
}
